var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.223 3H7.777a.948.948 0 0 0-.806.457L3.687 8.834h16.625L17.03 3.457a.962.962 0 0 0-.345-.335.936.936 0 0 0-.461-.122Zm-4.926 17.682A.953.953 0 0 0 12 21a.932.932 0 0 0 .703-.318l8.797-9.904h-19l8.797 9.904Z"
  })));
};
export default SvgDiamond;